import t, { forwardRef as _ } from "react";
import { Button as b } from "../button/basic-button.esm.js";
import "../button/download-button.esm.js";
import "../button/icon-button.esm.js";
import "../button/plain-icon-button.esm.js";
import "classnames";
import { DrawerDialog as h } from "./drawer-dialogue.esm.js";
import { D as S } from "../drawer-header-BHBOBwu7.mjs";
const x = {
  left: "left",
  right: "right",
  top: "top",
  bottom: "bottom"
}, y = _(
  ({
    children: r,
    title: e,
    backCallback: a = () => {
    },
    closeCallback: o = () => {
    },
    dataTestId: i,
    desktopDisplay: m = !0,
    hasBackButton: s = !1,
    promotionalArea: d,
    onClose: f = () => {
    },
    open: n = !1,
    stickyDrawer: l = {
      container: {
        className: "fuse-drawer__sticky-drawer",
        dataTestId: "fuse-drawer-sticky-drawer-data-testid",
        open: !1,
        transition: void 0,
        zIndex: void 0
      },
      button: /* @__PURE__ */ t.createElement(b, null)
    },
    slidePosition: p = x.right,
    srLabelBackButton: w,
    srLabelCloseButton: c,
    zIndex: u = "1",
    ...D
  }, g) => /* @__PURE__ */ t.createElement(
    h,
    {
      title: e,
      backCallback: a,
      closeCallback: o,
      dataTestId: i,
      desktopDisplay: m,
      hasBackButton: s,
      onClose: f,
      open: n,
      stickyDrawer: l,
      promotionalArea: d,
      ref: g,
      slidePosition: p,
      srLabelBackButton: w,
      srLabelCloseButton: c,
      zIndex: u,
      ...D
    },
    r
  )
);
y.displayName = "Drawer";
export {
  y as Drawer,
  S as DrawerHeader,
  x as DrawerSidesEnum
};
